export default __webpack_public_path__ + "static/media/sportstv.e24a6f42.svg";